import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    // Redirect to portal dashboard
    throw redirect({ to: "/portal" });
  },
});
